import { Injectable } from '@angular/core';
import { UrlFactory } from './url-factory';
import { Params } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class CommunicationPreferencesGateway {
  constructor(private _urlFactory: UrlFactory) {}
  communicationPreferencesUrl(params: Params = {}): string {
    return this._urlFactory.createUrl(
      'communicationPreferencesUrl',
      'v1/communications',
      params,
    );
  }
}
